import React, {
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from 'react';
import {
  Row,
  Col,
  Input,
  Switch,
} from 'antd';
import SimpleReactValidator from 'simple-react-validator';

import {
  SpH5,
  SpError,
} from 'components/DesignKit';

type Props = {
  paymentSuccessInfo: Object,
};

const PaymentOrder = (props: Props, ref) => {
  const {
    paymentSuccessInfo,
  } = props;

  const [, forceUpdate] = useState();
  const [content, setContent] = useState(paymentSuccessInfo.content);
  const [addition, setAddition] = useState(paymentSuccessInfo.addition);
  const [orderNumber, setOrderNumber] = useState(paymentSuccessInfo.orderNumber);
  const simpleValidator = useRef(new SimpleReactValidator());

  useImperativeHandle(ref, () => ({
    validate: () => {
      const formValid = simpleValidator.current.allValid();
      if (!formValid) {
        simpleValidator.current.showMessages();
        forceUpdate(1);
        return false;
      }
      paymentSuccessInfo.content = content;
      paymentSuccessInfo.addition = addition;
      paymentSuccessInfo.orderNumber = orderNumber;
      return true;
    },
  }));

  return (
    <>
      <div>
        <Row>
          <Col span={6} className="mb-2">
            <SpH5 className="mb-2">Successful Content</SpH5>
            <Input
              type="text"
              maxLength={30}
              onChange={(e) => { setContent(e.currentTarget.value); paymentSuccessInfo.content = e.currentTarget.value; }}
              value={content}
            />
            <SpError>
              {simpleValidator.current.message('successful content', content, 'required')}
            </SpError>
          </Col>
        </Row>
        <Row className="mb-2">
          <Col span={6}>
            <SpH5 className="mb-2">Additional  Content (Optional)</SpH5>
            <Input
              type="text"
              onChange={(e) => { setAddition(e.currentTarget.value); paymentSuccessInfo.addition = e.currentTarget.value; }}
              value={addition}
            />
          </Col>
        </Row>
        <Row>
          <Col span={6}>
            <SpH5 className="mb-2">Show Order Number (Optional)</SpH5>
            <div>
              <Switch
                defaultChecked={orderNumber}
                onChange={val => { setOrderNumber(val); paymentSuccessInfo.orderNumber = val; }}
              />
            </div>

          </Col>
        </Row>
      </div>
    </>
  );
};

export default forwardRef(PaymentOrder);
